import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './i18n/messages'

Vue.use(VueI18n)

const locale = localStorage.getItem('locale') || 'zh-CN'

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'zh-CN',
  messages
})

export default i18n
